import { TSocialLinkProps, TSocialMediaFields } from '../../../../../types/types';
import { TSocialMediaProps } from '../types/index.types';

export class SocialMediaModel {
  private readonly fields?: TSocialMediaFields;

  constructor(props: TSocialMediaProps) {
    this.fields = props.fields;
  }

  get socialLinks(): TSocialLinkProps[] {
    if (this.fields?.items && this.fields?.items?.length > 6) {
      return this.fields?.items?.slice(0, 6) || [];
    }
    return this.fields?.items || [];
  }
}
